import { Module } from 'vuex';
import { activitiesService } from '@/services';

interface State {
  title: string;
  metaKeywords: string;
  metaDescription: string;

  items: Array<any>;
  pageCount: number;
  count: number;
  limit: number;
  page: number;

  errorMessage: string;
  errors: Array<any>;
}

export const SET_ITEMS = 'setItems';
export const SET_COUNT = 'setCount';
export const SET_PAGE = 'setPage';
export const SET_PAGE_COUNT = 'setPageCount';
export const SET_LIMIT = 'setLimit';
export const SET_ERRORS = 'setErrors';
export const SET_ERROR_MESSAGE = 'setErrorMessage';

const createStoreModule = (providers: any): Module<State, any> => {
  const { $api } = providers;
  return {
    namespaced: true,
    state: (): State => ({
      title: 'Заявки на мероприятие',
      metaKeywords: '',
      metaDescription: '',
      items: [],

      pageCount: 0,
      count: 0,
      limit: 9,
      page: 1,

      errorMessage: '',
      errors: [],
    }),
    mutations: {
      [SET_ITEMS](state, items: Array<any>) {
        state.items = items;
      },
      [SET_ERRORS](state, errors: Array<any>) {
        state.errors = errors;
      },
      [SET_ERROR_MESSAGE](state, errorMessage: string) {
        state.errorMessage = errorMessage;
      },

      [SET_COUNT](state: State, value: number) {
        state.count = value;
      },

      [SET_PAGE](state: State, value: number) {
        state.page = value;
      },

      [SET_LIMIT](state: State, value: number) {
        state.limit = value;
      },

      [SET_PAGE_COUNT](state: State) {
        state.pageCount = Math.ceil(state.count / state.limit) || 0;
      },
    },
    actions: {
      async fetch({ commit }, params: any) {
        try {
          const response = await activitiesService($api).getActivitiesOrder(
            params
          );
          const { data, page, limit, filtered, errors, message } = response;
          commit(SET_ITEMS, data || []);
          commit(SET_ERRORS, errors || []);
          commit(SET_ERROR_MESSAGE, message || '');
          commit(SET_PAGE, Number(page));
          commit(SET_LIMIT, Number(limit));
          commit(SET_COUNT, Number(filtered));
          commit(SET_PAGE_COUNT);
        } catch (err) {
          commit(SET_ITEMS, []);
          commit(SET_PAGE, 1);
          commit(SET_COUNT, 0);
          commit(SET_LIMIT, 9);
          commit(SET_PAGE_COUNT);
        }
      },

      async orderHide({ dispatch, state, commit }, id: string) {
        // 'activities/order/hide/'
        const response = await activitiesService($api).hide(id);
        const { errors, message } = response;
        const { page, limit } = state;
        if (errors) {
          commit(SET_ERRORS, errors || []);
          commit(SET_ERROR_MESSAGE, message || '');
        } else {
          dispatch('fetch', { page, limit });
        }
      },

      async postClose({ dispatch, state, commit }, payload: any) {
        const { page, limit } = state;
        const response = await activitiesService($api).cancelActivity(
          payload.orderId
        );
        const { errors, message } = response;
        commit('setErrors', errors || []);
        commit('setErrorMessage', message || '');
        if (!errors) {
          await dispatch('fetch', { page, limit });
        }
      },
    },
  };
};

export { createStoreModule };



// WEBPACK FOOTER //
// ./src/pages/profile/views/purchases/pages/purchases-activity/store.ts